import { jsx as e } from "@emotion/react/jsx-runtime";
import { useTheme as d } from "@emotion/react";
import p from "rc-slider";
import { SliderContainer as h, railStyle as f, trackStyle as u, handleStyle as v, activeDotStyle as C, dotStyle as D } from "./Slider.styled.js";
const j = ({
  min: r = 0,
  max: l = 100,
  dots: i = !0,
  step: o = 1,
  value: a,
  onSliderChange: n,
  cssContainer: y,
  dotStyle: m = D,
  activeDotStyle: S,
  handleStyle: c,
  ...s
}) => {
  const t = d();
  return /* @__PURE__ */ e(h, { css: y, children: /* @__PURE__ */ e(p, { min: r, max: l, step: o, value: a, dots: i, "aria-label": "slider", onChange: n, dotStyle: m, activeDotStyle: S ?? C(t.colors.primary.initial), styles: {
    handle: {
      ...v(t.colors.primary.initial),
      ...c
    },
    track: u(t.colors.primary.initial),
    rail: f
  }, ...s }) });
};
export {
  j as Slider
};
